import { render, staticRenderFns } from "./EmptyParentComponent.vue?vue&type=template&id=1874c220&scoped=true"
import script from "./EmptyParentComponent.vue?vue&type=script&lang=js"
export * from "./EmptyParentComponent.vue?vue&type=script&lang=js"
import style0 from "./EmptyParentComponent.vue?vue&type=style&index=0&id=1874c220&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874c220",
  null
  
)

export default component.exports